const rlang = window.rlang;
export default rlang;